import {
  Container,
  Header,
  AppLayout,
  ContentLayout,
  Grid,
  Spinner,
  SpaceBetween,
  Alert,
  Button,
} from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useApiNoBody } from '../../../common/api';
import { LocalNavigation, Breadcrumbs, NavigationContext } from '../../../common/navigation';
import { UserListResponse } from '../../../common/types';
import Feed from '../../../feed/feed';

import { UserDetails } from './details';
import { UserRolesInfo } from './roles';
import { UserSubInfo } from './subscription';
import { UserTransactions } from './transactions';

export default function UserPage() {
  const { navigationSize, navigationOpen, setNavigationOpen } = useContext(NavigationContext);

  const params = useParams();
  // user UUID
  const userId = params.userId ?? '';
  const [user, setUser] = useState<UserListResponse>();

  const [userApi, error, loading] = useApiNoBody<UserListResponse>('/users', 'GET', setUser);

  const fetchUser = async () => {
    await userApi(undefined, userId);
  };

  useEffect(() => {
    if (userId) {
      fetchUser();
    }
  }, [userId]);

  return (
    <AppLayout
      breadcrumbs={
        <Breadcrumbs
          items={[
            { text: 'Manage', href: '' },
            { text: 'Users', href: '/manage/users' },
            {
              text: userId,
              href: '',
            },
          ]}
        />
      }
      className="app-layout"
      content={
        user ? (
          <ContentLayout
            header={<Header variant="h1">{`${user.given_name} ${user.family_name}`}</Header>}
          >
            <Grid
              gridDefinition={[
                { colspan: { default: 12, s: 5 } },
                { colspan: { default: 12, s: 7 } },
              ]}
            >
              <SpaceBetween size="l">
                <UserDetails setUser={setUser} user={user} />
                <UserSubInfo user={user} />
                {/* Allow adding roles like admin */}
                <UserRolesInfo setUser={setUser} user={user} />
              </SpaceBetween>
              <SpaceBetween size="l">
                {/* <UserRooms user={user} /> */}
                {/* TODO replace with user feed */}
                <Feed
                  eventLimit={5}
                  eventType="created"
                  userId={user.id}
                  disableScroll
                  hideUsers
                  horizontal
                />
                <UserTransactions user={user} />
              </SpaceBetween>
            </Grid>
          </ContentLayout>
        ) : loading ? (
          <ContentLayout header={<Header variant="h2">Loading</Header>}>
            <Grid gridDefinition={[{ colspan: { s: 10, default: 12 } }]}>
              <Container>
                <Spinner size="big" />
              </Container>
            </Grid>
          </ContentLayout>
        ) : (
          <ContentLayout header={<Header variant="h2">Error</Header>}>
            <Grid gridDefinition={[{ colspan: { s: 10, default: 12 } }]}>
              <Alert
                action={
                  <Button
                    loading={loading}
                    variant="normal"
                    onClick={() => {
                      fetchUser();
                    }}
                  >
                    Retry
                  </Button>
                }
                header="User Error"
                statusIconAriaLabel="Error"
                type="error"
              >
                {error}
              </Alert>
            </Grid>
          </ContentLayout>
        )
      }
      contentType="default"
      headerSelector=".top-navigation"
      navigation={<LocalNavigation />}
      navigationOpen={navigationOpen}
      navigationWidth={navigationSize}
      toolsHide
      onNavigationChange={(event) => setNavigationOpen(event.detail.open)}
    />
  );
}
